import script from "./sf-workflow-status-dropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-workflow-status-dropdown.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__